import { onClickOutside } from '@vueuse/core'
import { sendMessage } from '../services/websocket'
import { usePaths } from './useFilePath'
const utility = () => {
  // reusable function to register onClickOutside for any element.

  function registerClickOutside(elementRef, clickOutsideHandler, ignoreList) {
    onClickOutside(
      //element to register outside click
      elementRef,
      () => {
        //function to run
        clickOutsideHandler();
      },
      {
        //refs to ignore form the outside click
        ignore: ignoreList
      }
    )
  }

  // this function takes an object and makes all its values to null
  // function is moved here from nullMaker.js and the nullMaker.js composable is not deleted
  function getNullObject(obj) {
    for (var key in obj) {
      obj[key] = null
    }
    return obj
  }


  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  function getRelativeDownloadPath(filePath) {
    if (!filePath) {
      return null
    }

    const markers = [
      '/file_uploads',
      '/Downloads',
      '/payslips',
      '/invoices',
      '/reports',
      'file_uploads',
      'Downloads',
      'payslips',
      'invoices',
      'reports'
    ]

    for (const marker of markers) {
      const startIndex = filePath.indexOf(marker)
      if (startIndex !== -1) {
        return filePath.slice(startIndex).replace(/^\/+/, '')
      }
    }

    return null
  }

  function getDownloadUrl(filePath) {
    const relativePath = getRelativeDownloadPath(filePath)
    if (!relativePath) {
      return null
    }

    const { fileServePath } = usePaths()
    return `${fileServePath}/${relativePath}`
  }

  function resolveBulkPayslipPeriod(payload) {
    if (payload == null) {
      return null
    }

    if (typeof payload === 'string') {
      return payload
    }

    return payload.payPeriod
      ?? payload.pay_period
      ?? payload.data?.payPeriod
      ?? payload.data?.pay_period
      ?? null
  }

  async function payslipsDownload(payslips, folder, store) {
    const serverPort = store.getters['serverPortGetter']

    for (var i = 0; i < payslips.length; i++) {
      const currPayslip = payslips[i]
      const currUconst = currPayslip.uconst
      const getTxn = folder.txns.txn_payslips_get_payslip
      const params = {'uconst':currUconst}
      getTxn.params = params
      const retVal = await sendMessage(getTxn)
      if (retVal.output.type == 'success') {
        const fileName = retVal.output.fileName
        const start = fileName.indexOf('payslips');
        const result = fileName.substring(start);
        const url = `http://${window.location.hostname}:${serverPort}/${result}`
        window.open(url, '_blank')

      }

    }
  }

  async function payslipsBulkDownload(txn, store, payload) {
    const sessionId = store.getters['sessionIdGetter']
    const payPeriod = resolveBulkPayslipPeriod(payload)

    if (!payPeriod) {
      throw new Error('Pay period is required for bulk payslip download.')
    }

    const txnToRun = JSON.parse(JSON.stringify(txn))
    txnToRun.params = { payPeriod }
    txnToRun.session_key = sessionId
    txnToRun.swhandle = txnToRun.swhandle || store.getters['bSettings']?.env?.swhandle || store.getters['userModule/swHandle']

    const retVal = await sendMessage(txnToRun)
    if (retVal?.output?.type === 'success') {
      const filePath = retVal.output.filePath || retVal.output.fileName
      const url = getDownloadUrl(filePath)
      if (url) {
        window.open(url, '_blank')
      }
    }

    return retVal
  }


  return { registerClickOutside, getNullObject, debounce, payslipsDownload, payslipsBulkDownload }
}

export default utility
